import { registerQuery } from 'data-fetching-client';
import { getInAppPhoneNumberRpc } from 'growth-monetization-service-types';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getEarlyRequestResult } from '../utils/earlyRequest';

// ******************* In-App ***********************
const rpcClientAuth = createRpcClientV2({
  hubHttpClient: http
});
export const GET_PHONE_NUMBER = registerQuery({
  fieldName: 'phoneNumber',
  args: ['earlyRequestName', 'preferredLanguage'],
  fetcher({
    earlyRequestName,
    preferredLanguage
  }) {
    return getEarlyRequestResult(earlyRequestName, () => rpcClientAuth.call(getInAppPhoneNumberRpc, {
      pathParameters: {
        preferredLanguage
      }
    }));
  }
});